import * as moment from 'moment';
import * as _ from 'lodash';

import { Component, OnInit, ViewChild } from '@angular/core';
import { CALENDAR_LOCALE } from '../../services/constant';
import { ApiService } from '../../services/api.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../services/authentication.service';


@Component({
  selector: 'app-manage-request',
  templateUrl: './manage-request.component.html',
  styleUrls: ['./manage-request.component.scss']
})
export class ManageRequestComponent implements OnInit {
  calendarLocale = CALENDAR_LOCALE.TH;
  currentPage: 1;
  invoiceNumber: string;
  itemsPerPage = 40;
  loading = false;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  statusChoices = [
    {label: 'ทั้งหมด', value: null},
    {label: 'รอดำเนินการ', value: 'pending'},
    {label: 'อนุมัติ', value: 'approved'},
    {label: 'ปฏิเสธ', value: 'rejected'},
  ]
  requestTypes = [
    {label: 'ทั้งหมด', value: null},
    {label: 'ขอลบเอกสาร', value: 'delete_document'},
    {label: 'ขอแก้ไขเอกสาร', value: 'edit_document'},
  ]
  requestNo: string;
  requestType: string;
  requestUser: string;
  status: string;
  tableData: any[];
  totalItems: number;
  selectedRequest: any;
  modal: NgbModalRef;
  reason: string;
  resultMessage: string;
  submitting = false;

  @ViewChild('resultModal') resultModal: any;

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.endDate = new Date();
    this.search();
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  get isSystemAdmin(): boolean {
    return this.authService.isSystemAdmin() || this.authService.isAdmin();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  search(resetPageNUmber = true) {
    if (resetPageNUmber) {
      this.currentPage = 1;
    }

    this.loading = true;
    const params = {
      page: this.currentPage,
      page_size: this.itemsPerPage,
      invoice_number: this.invoiceNumber || '',
      request_no: this.requestNo || '',
      request_date_after: moment(this.startDate).format('YYYY-MM-DD'),
      request_date_before: moment(this.endDate).format('YYYY-MM-DD'),
      request_type: this.requestType || '',
      request_user: this.requestUser || '',
      status: this.status || '',
    }

    this.apiService.getDocumentRequests(null, params).subscribe(
      (response) => {
        this.tableData = response.results;
        this.totalItems = response.count;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  pageChanged() {
    this.search(false);
  }

  optionChanged() {
    this.search();
  }

  clearSearch() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.endDate = new Date();
    this.invoiceNumber = null;
    this.requestNo = null;
    this.requestUser = null;
    this.requestType = null;
    this.status = null;
  }

  openModal(contentModal, data, size?: string) {
    this.selectedRequest = data;
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static'
    }

    if (size) {
      modalOptions.size = size as any;
    }
    this.modal = this.modalService.open(contentModal, modalOptions);
  }

  reject() {
    if (!this.reason || !this.selectedRequest) {
      return;
    }
    this.submitting = true;
    this.apiService.rejectDocumentRequest(this.selectedRequest.id, {reason: this.reason}).subscribe(
      () => {
        this.resultMessage = 'ดำเนินการสำเร็จ';
        this.modal.close();
        this.modal = this.modalService.open(this.resultModal, {centered: true, backdrop: 'static'});
      },
      (error) => {
        this.resultMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        this.modal.close();
        this.modal = this.modalService.open(this.resultModal, {centered: true, backdrop: 'static'});
      }
    )
  }

  approve() {
    if (!this.selectedRequest) {
      return;
    }

    this.apiService.approveDocumentRequest(this.selectedRequest.id).subscribe(
      () => {
        this.resultMessage = 'ดำเนินการสำเร็จ';
        this.modal.close();
        this.modal = this.modalService.open(this.resultModal, {centered: true, backdrop: 'static'});
      },
      (error) => {
        this.resultMessage = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง';
        this.modal.close();
        this.modal = this.modalService.open(this.resultModal, {centered: true, backdrop: 'static'});
      }
    );
  }

  closeModal(search = false) {
    this.modal.close();
    this.submitting = false;
    this.reason = null;
    this.resultMessage = null;
    this.selectedRequest = undefined;

    if (search) {
      this.search(false);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request.component.ts